import { resetRequestStatus, setActiveUserId } from '@state/users/userSlice';
import { Dispatch } from 'redux';

export const returnBackToUserList = (dispatch: Dispatch) => {
  dispatch(setActiveUserId(''));
  dispatch(resetRequestStatus());
};
